import { render, staticRenderFns } from "./SantanderJuridico.vue?vue&type=template&id=240fcd55&scoped=true&"
import script from "./SantanderJuridico.vue?vue&type=script&lang=js&"
export * from "./SantanderJuridico.vue?vue&type=script&lang=js&"
import style0 from "./SantanderJuridico.vue?vue&type=style&index=0&id=240fcd55&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240fcd55",
  null
  
)

export default component.exports